import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { InstallationFeaturesStore } from '@store';
import {
  DcSensorValueProperties,
  Feature,
  FeatureNames,
  FeaturePropertyKey,
  HeatingConfigurationInternalPumps,
  HeatingSecondaryCircuitValvesFourThreeWayProperties,
  HeatingValvuesFourThreeWayPositionProperties,
  IsNumberValueProperty,
} from '@vi-iot/client/index';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-internal-hydraulic-related-parameters',
  templateUrl: './internal-hydraulic-related-parameters.component.html',
  styleUrls: ['./internal-hydraulic-related-parameters.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InternalHydraulicRelatedParametersComponent implements OnInit {
  readonly featurePropertyKey = FeaturePropertyKey;
  internalHydraulicHeatingWaterVolumeFlow$: Observable<Feature<DcSensorValueProperties, never>>;
  internalHydraulicFourThreeWayValve$: Observable<
    Feature<HeatingSecondaryCircuitValvesFourThreeWayProperties, never>
  >;
  internalHydraulicFourThreeWayValvePosition$: Observable<
    Feature<HeatingValvuesFourThreeWayPositionProperties, never>
  >;
  internalHydraulicCommonFlowTemperature$: Observable<Feature<DcSensorValueProperties, never>>;
  internalHydraulicReturnTemperature$: Observable<Feature<DcSensorValueProperties, never>>;
  primaryCircuitPumpSetpoint$: Observable<Feature<IsNumberValueProperty, never>>;
  internalHydraulicConfigurationInternalPumps$: Observable<
    Feature<HeatingConfigurationInternalPumps, never>
  >;
  internalHydraulicSystemPressure$: Observable<Feature<DcSensorValueProperties, never>>;
  internalHydraulicActualVolumeFlow$: Observable<Feature<IsNumberValueProperty, never>>;

  @Input() deviceId: string;

  constructor(public installationFeaturesStore: InstallationFeaturesStore) {}

  ngOnInit(): void {
    this.internalHydraulicHeatingWaterVolumeFlow$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.volumetricFlowReturn,
      this.deviceId
    );

    this.internalHydraulicFourThreeWayValve$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.secondaryValvesFourThreeWay,
      this.deviceId
    );

    this.internalHydraulicFourThreeWayValvePosition$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.secondaryValvesFourThreeWayPosition,
      this.deviceId
    );

    this.internalHydraulicCommonFlowTemperature$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.boilerCommonSupplyTemperature,
      this.deviceId
    );

    this.internalHydraulicReturnTemperature$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.returnFlowTemperature,
      this.deviceId
    );

    this.primaryCircuitPumpSetpoint$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.boilerPumpsInternalTarget,
      this.deviceId
    );

    this.internalHydraulicConfigurationInternalPumps$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.configurationInternalPumps,
      this.deviceId
    );

    this.internalHydraulicActualVolumeFlow$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.boilerPumpsInternalCurrent,
      this.deviceId
    );

    this.internalHydraulicSystemPressure$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.waterPressure,
      this.deviceId
    );
  }
}
